import { GridHeaders } from '@project-types/GridHeaders';
import { CustomerReportGridData } from '@pages/reporting-pages/deliveries-customer/types/CustomerReportGridData';



export const headersObject: GridHeaders<CustomerReportGridData> = [
	{ label: 'ON Trade / OFF Trade', key: 'onOffTrade', width: '1fr' },
	{ label: 'Stát', key: 'country', width: '1fr' },
	{ label: 'Zákazník', key: 'destinationName', width: '1fr' },

	{ label: 'Total - Objem [hl]', key: 'total_volume', width: '1fr' },
	{ label: 'Total - Váha [t]', key: 'total_weight', width: '1fr' },
	{ label: 'Total - Váha vratky [t]', key: 'total_returnsWeight', width: '1fr' },
	{ label: 'Total - Počet objednávek', key: 'total_ordersCount', width: '1fr' },
]